<template>
<div>
    <v-row class="justify-center">
        <v-col cols="12" sm="8" md="6">
            <div class="text-center subtitle-2 font-weight-medium mt-4 mb-2 info--text">
                EMAIL
            </div>

            <v-card outlined>
                <v-card-text class="py-10">
                    <div class="d-flex justify-center text-center caption primary--text font-weight-medium mb-3" v-if="$vuetify.breakpoint.smAndDown">
                        EMAIL
                    </div>
                    <div class="d-flex justify-center text-center subtitle-1 font-weight-regular black--text">
                        {{user.email}}
                    </div>
                    <div class="d-flex justify-center mt-4">
                        <v-btn depressed class="accent" @click="showDiag=true">Edit</v-btn>
                    </div>
                </v-card-text>
            </v-card>

            <!-- <v-divider class="mt-8" v-if="$vuetify.breakpoint.mdAndUp"></v-divider> -->
        </v-col>
    </v-row>

    <DiagEmail
        :model="showDiag"
        @requiresRecentLogin="requiresLogin"
        @cancel="showDiag=false"
        @changed="changed" />
    
    <DiagInfo
        :model="showRecentLogin"
        text="<b class='red--text text--darken-1'>No se ha realizado el cambio.</b> <br /><br />Por motivos de seguridad es necesario que cierres sesión y vuelvas a ingresar, para que puedas realizar un cambio de correo."
        @accept="showRecentLogin=false" />
</div>
</template>

<script>
import DiagEmail from '@/components/core/dialogs/DiagEmail'
import Sign from '@/firebase/sign'

export default {
    data: () => ({
        showDiag: false,
        showRecentLogin: false
    }),
    components: {
        DiagEmail
    },
    methods: {
        changed() {
            Sign.reInitUser(this.user.uid);
            this.showDiag = false;
        },
        requiresLogin() {
            this.showDiag = false;
            this.showRecentLogin = true;
        }
    }
}
</script>